import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, switchMap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.isLoading$.pipe(
    filter((isLoading) => !isLoading),
    switchMap(() => auth.isAuthenticated$),
  );
};
